module.exports = __webpack_public_path__ + "static/img/bg-ar.8411b208.webp";